import script from "./QuadRadiusField.vue?vue&type=script&setup=true&lang=js"
export * from "./QuadRadiusField.vue?vue&type=script&setup=true&lang=js"

import "./QuadRadiusField.vue?vue&type=style&index=0&id=f8e660d6&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8e660d6"]])

export default __exports__